import React, { useState, useEffect } from "react";
import CardActivity from '../../components/CardActivity'
import HeaderText from '../../components/HeaderText'
import { Button, Row, Col, Card, ListGroup } from 'react-bootstrap'
import AuthService from "../../controllers/AuthService";
import { Helmet } from "react-helmet";
import UserService from "../../controllers/UserService";
import $ from 'jquery';
import { Doughnut } from "react-chartjs-2";
import { useParams } from 'react-router-dom';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import CardYear from "../../components/CardYear";
import ReportSummary from "../../components/riasec/ReportSummary";
import { Chart, ArcElement } from 'chart.js'
import WelcomeDialog from "../../components/login/WelcomeDialog";
import FriendshipGame from "../../components/Game/FriendshipGame";
import rData from "../../files/RiasecData.json";


Chart.register(ArcElement);

const ReportPage = props => {

    const [styleShow, setStyleShow] = useState('');
    const [homeroomD1, setHomeroomD1] = useState();
    const [friendshipD1, setFriendshipD1] = useState();
    const [friendshipD2, setFriendshipD2] = useState();
    const [strengths, setStrengths] = useState([]);

    //for master head
    const [totalContent, setTotalContent] = useState([]);
    const [topContent, setTopContent] = useState([]);

    //for frendship report student
    const [roomName, setRoomName] = useState([]);
    const [allPercent, setSetPercent] = useState([]);
    const [key, setSetKey] = useState([]);
    const [selfText, setSelfText] = useState([]);
    const [graphData, setGraphData] = useState(null);
    const [maxValue, setMaxValue] = useState(0);
    const [studentName, setStudentName] = useState('');
    const [totalActivity, setTotalActivity] = useState(0);
    const [totalActivityCount, setTotalActivityCount] = useState(0);
    const [totalStudentCount, setTotalStudentCount] = useState(0);
    const [totalTeacherCount, setTotalTeacherCount] = useState(0);
    const [styleFriendShip, setStyleFriendShip] = useState('');
    const [styleSubFriendShip, setStyleSubFriendShip] = useState('');

    const [roomId, setRoomId] = useState('');
    const [rId, setRId] = useState('');
    const [sId, setSId] = useState('');
    const [styleDashboardH, setStyleDashboardH] = useState('');
    const [styleDashboardT, setStyleDashboardT] = useState('');
    const [styleDashboardS, setStyleDashboardS] = useState('');
    const [roomStrengths, setRoomStrengths] = useState('');
    const [roomStrengthsMobile, setRoomStrengthsMobile] = useState([]);

    const [hGraphData1, setHGraphData1] = useState(null);
    const [hGraphData2, setHGraphData2] = useState(null);
    const [keyH1, setSetKeyH1] = useState([]);
    const [keyH2, setSetKeyH2] = useState([]);
    const [timeCount1, setTimeCount1] = useState([]);
    const [timeCount2, setTimeCount2] = useState([]);

    const [teacherD1, setTeacherD1] = useState(false);
    const [teacherD2, setTeacherD2] = useState(false);
    const [friendD1, setFriendD1] = useState(false);
    const [headmasterD1, setHeadmasterD1] = useState(false);
    const [headmasterD2, setHeadmasterD2] = useState(false);

    const [featureHomeroom, setFeatureHomeroom] = useState(false);

    const [roomyear, setRoomyear] = useState(null);
    const [roomterm, setRoomterm] = useState(null);
    const [roomgrade, setRoomgrade] = useState(null);
    const [roomgradeyear, setRoomgradeyear] = useState(null);



    const timeMinute = 20;
    var temp = [];
    let newStrengths = [];
    let color = {

        "brave": "#FFCECE",
        "honesty": "#FF9B9B",
        "perseverance": "#E04E4E",
        "zest": "#B41616",
        "fairness": "#A1AEF9",
        "citizenship": "#465BCC",
        "leadership": "#1A2979",
        "humility": "#FFD2F5",
        "forgiveness": '#FFA1E9',
        "self_regulation": "#D761BB",
        "prudence": "#801967",
        "hope": "#FFDEC8",
        "spirituality": "#FFC096",
        "beauty_excellence": "#EA833D",
        "humor": "#E46C1A",
        "gratitude": '#923806',
        "creativity": "#CDFFF6",
        "curiosity": '#8FFFEA',
        "judgement": "#67D2BE",
        "love_of_learning": "#2FA992",
        'perspective': '#147B68',
        "kindness": "#D8F4FF",
        "social": "#96DAF5",
        "love": "#2893BD",
    };

    let studentId = '';
    let labelsValue = [], backgroundColorValue = [], dataValue = [];
    let labelsValueH1 = [], backgroundColorValueH1 = [], dataValueH1 = [];
    let labelsValueH2 = [], backgroundColorValueH2 = [], dataValueH2 = [];
    let roomStrengthsAll = []

    const search = window.location.search;
    const params = new URLSearchParams(search);
    let currentY = params.get('qyear') || '0';
    let currentT = params.get('qterm') || '0';
    let currentRoom = params.get('qroom') || '0';

    const settings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        slidesPerRow: 1,
        centerMode: true,
        arrows: false
    };

    let [top1, setTop1] = useState('');
    let [top2A, setTop2A] = useState('');
    let [top2B, setTop2B] = useState('');
    let [skill, setSkill] = useState([]);
    let [assessor, setAssessor] = useState('STUDENT');

    useEffect(() => {
        props.onChange({ 'backgroundColor': 'bg-lightness2-blue' })

        const userRole = AuthService.getUserRole();
        const userFeature = AuthService.getCurrentUserFeatures();

        setFeatureHomeroom(userFeature && userFeature.includes('homeroom'));

        if (userRole === 'headmaster') {
            setStyleDashboardT('d-none');
            setRId(currentRoom)
            const user = AuthService.getCurrentUser();
            const userDomain = user.domain.name;
            UserService.distinctYearTerm().then((response) => {
                response.data.data = response.data.data.reverse();
                if (currentY === '0' && response.data.data && response.data.data[0] && response.data.data[0].year) {
                    currentY = response.data.data[0].year;
                }

                if (currentT === '0' && response.data.data && response.data.data[0] && response.data.data[0].term) {
                    currentT = response.data.data[0].term;
                }

            }).then(() => {
                setStyleDashboardS('d-none');
                setStyleFriendShip('d-none');
                var filter = {
                    "domain": userDomain,
                    "year": currentY,
                    "term": currentT,
                };
                UserService.activitiesGradeYearAll(filter).then((response) => {
                    const dataAll = response.data.data
                    let tempData = [null, null, null, null, null, null];
                    let countActivity = 0
                    let countTeacher = 0
                    let countStudent = 0
                    for (let i = 0; i < 6; i++) {
                        if (dataAll[i]) {
                            countActivity += dataAll[i].totalActivities
                            countTeacher += dataAll[i].totalTeachers
                            countStudent += dataAll[i].totalStudents

                            var tempIndex = dataAll[i].gradeYear - 1;

                            tempData[tempIndex] = dataAll[i];
                        }
                    }


                    setHomeroomD1(tempData);
                    // console.log(tempData)
                    setTotalTeacherCount(countTeacher)
                    setTotalStudentCount(countStudent)
                    setTotalActivityCount(countActivity)
                });

                // ?limit=3&sort=usageCount
                UserService.getTopics({
                    "limit": '3',
                    "sort": 'usageCount'
                }).then((response) => {
                    setTotalContent(response.data.total);
                    setTopContent(response.data.data);
                    // console.log(response.data.data);
                });

                UserService.getStrengths().then((response) => {

                    for (const [index, str] of response.data.data.entries()) {
                        newStrengths[str.id] = {
                            image: str.imageUrl,
                            name: str.name,
                            description: str.description
                        }
                    }
                    setStrengths(newStrengths)
                    return newStrengths
                }).then((apiStrengths) => {
                    var filter2 = {
                        "domain": userDomain,
                        "year": currentY,
                        "term": currentT,
                    };
                    // summaryStrength คืนทั้งนักเรียน (student) และครู (teacher) ในครั้งเดียว
                    UserService.summaryStrength(filter2).then((result) => {

                        // จุดเด่นของนักเรียน
                        var studentData = result.student || [];
                        setFriendshipD1(studentData);
                        setHeadmasterD1(studentData.length > 0);
                        var key1 = [];
                        var timeCount1 = [];
                        $.each(studentData, function (index, value) {
                            timeCount1[value.name] = value.total + " ครั้ง";
                            key1.push(value.name);
                            labelsValueH1.push(newStrengths[value.name]?.name);
                            backgroundColorValueH1.push(color[value.name]);
                            dataValueH1.push(value.total);
                        });
                        var gh1 = {
                            labels: labelsValueH1,
                            datasets: [
                                {
                                    label: 'Rainfall',
                                    backgroundColor: backgroundColorValueH1,
                                    data: dataValueH1
                                }
                            ]
                        };
                        setHGraphData1(gh1);
                        setSetKeyH1(key1);
                        setTimeCount1(timeCount1);

                        // จุดเด่นของคุณครู
                        var teacherData = result.teacher || [];
                        setFriendshipD2(teacherData);
                        setHeadmasterD2(teacherData.length > 0);
                        var key2 = [];
                        var timeCount2 = [];
                        $.each(teacherData, function (index, value) {
                            timeCount2[value.name] = value.total + " ครั้ง";
                            key2.push(value.name);
                            labelsValueH2.push(newStrengths[value.name]?.name);
                            backgroundColorValueH2.push(color[value.name]);
                            dataValueH2.push(value.total);
                        });
                        var gh2 = {
                            labels: labelsValueH2,
                            datasets: [
                                {
                                    label: 'Rainfall',
                                    backgroundColor: backgroundColorValueH2,
                                    data: dataValueH2
                                }
                            ]
                        };
                        setHGraphData2(gh2);
                        setSetKeyH2(key2);
                        setTimeCount2(timeCount2);

                    });

                });
            });
        } else {



            if (userRole === 'student') {

                setStyleShow('d-none');
                setStyleDashboardH('d-none')
                setStyleDashboardT('d-none')
                const data = AuthService.getCurrentUser();
                const rName = (data.room && data.room.displayName) ? data.room.displayName : '';
                const rRoomId = (data.room && data.room.id) ? data.room.id : ''
                // setRoomName(rName); 
                // setRoomId(rRoomId);

                try {

                    currentY = currentY === '0' ? AuthService.getUserCurrentYear() : currentY;
                    currentT = currentT === '0' ? AuthService.getUserCurrentTerm() : currentT;
                    currentRoom = currentRoom === '0' ? rRoomId : currentRoom;
                    var user = AuthService.getCurrentUser();
                    //todo ปีการศึกษา        
                    studentId = user.id;
                    setSId(user.id)
                    setStudentName(user.fullName);

                    // ---------------------------------------
                    UserService.getActivities({
                        roomId: currentRoom,
                        year: currentY,
                        term: currentT
                    }).then((res) => {
                        console.log(res);
                        setTotalActivityCount(res.data.total);
                    });
                    // ---------------------------------------

                    var filter;
                    UserService.getRoomDetail(currentRoom).then((response) => {
                        //handel data not found
                        setRoomName(response.data.data.displayName);
                        setRoomId(response.data.data.id);

                        setRoomyear(response.data.data.year);
                        setRoomterm(response.data.data.term);
                        setRoomgrade(response.data.data.grade);
                        setRoomgradeyear(response.data.data.gradeYear);

                        return filter = {
                            "domain": user.domain.name,
                            "roomId": currentRoom,
                            "year": response.data.data.year,
                            "term": response.data.data.term,
                        };

                    }).then(() => {

                        UserService.activitiesTotal(filter).then((response) => {

                            var total = 0;
                            if (response && response.data && response.data.data[0]) {
                                total = response.data.data[0].total;
                            }

                            return total;
                        }).then((total) => { setTotalActivity(total) });

                        UserService.getStrengths().then((response) => {

                            for (const [index, str] of response.data.data.entries()) {
                                newStrengths[str.id] = {
                                    image: str.imageUrl,
                                    name: str.name,
                                    description: str.description
                                }
                            }
                            setStrengths(newStrengths)
                            return newStrengths
                        }).then((apiStrengths) => {
                            // console.log(apiStrengths);
                            UserService.getFriendShipList(studentId, filter).then((res) => {
                                if (res.data.data == [] || res.data.data == '') {
                                    setFriendD1(false);
                                } else {
                                    setFriendD1(true);
                                }

                                var allAnswer0 = [];
                                var sum = 0;
                                var maxPercent = 0;
                                var percent = [];
                                var key = [];
                                if (res.data.data[0] != undefined && userRole === 'student') {


                                    for (const [index, aAnswer] of res.data.data[0].others.entries()) {
                                        //console.log(aAnswer);    

                                        if (aAnswer.answerAt != null) {
                                            sum += 3;

                                            if (allAnswer0[aAnswer.answers[0].values[0]] === undefined) {
                                                allAnswer0[aAnswer.answers[0].values[0]] = 1;
                                            } else {
                                                allAnswer0[aAnswer.answers[0].values[0]]++
                                            }

                                            if (allAnswer0[aAnswer.answers[1].values[0]] === undefined) {
                                                allAnswer0[aAnswer.answers[1].values[0]] = 1;
                                            } else {
                                                allAnswer0[aAnswer.answers[1].values[0]]++
                                            }


                                            if (allAnswer0[aAnswer.answers[2].values[0]] === undefined) {
                                                allAnswer0[aAnswer.answers[2].values[0]] = 1;
                                            } else {
                                                allAnswer0[aAnswer.answers[2].values[0]]++
                                            }

                                            if (studentId === aAnswer.user.id) {
                                                var selfText = aAnswer.answers[3].values[0];
                                                setSelfText(selfText);
                                            }

                                        }

                                    }

                                    // console.log(allAnswer0);
                                    var myArr0 = Object.fromEntries(
                                        Object.entries(allAnswer0).sort(([, a], [, b]) => b - a)
                                    );


                                    $.each(myArr0, function (index, value) {
                                        var numberValue = ((value * 100) / sum).toFixed(2);
                                        percent[index] = numberValue + "%";
                                        key.push(index);
                                        labelsValue.push(newStrengths[index].name);
                                        backgroundColorValue.push(color[index]);
                                        dataValue.push(numberValue);
                                        if (parseFloat(maxPercent) < parseFloat(numberValue)) {
                                            maxPercent = parseFloat(numberValue);
                                        }
                                    });

                                    if (Object.keys(myArr0).length <= 0) {
                                        setStyleSubFriendShip('d-none')
                                    } else {

                                    }

                                } else {

                                    setStyleFriendShip('d-none');
                                    setFriendD1(false);
                                }

                                var data = { 'percent': percent, 'key': key, 'maxPercent': maxPercent };
                                return data;

                            }).then((res) => {

                                setSetPercent(res.percent);
                                setSetKey(res.key);
                                setMaxValue(res.maxPercent)

                            }).then((res) => {
                                var graphData2 = {
                                    labels: labelsValue,
                                    datasets: [
                                        {
                                            label: 'Rainfall',
                                            backgroundColor: backgroundColorValue,
                                            // hoverBackgroundColor: [
                                            // '#501800',
                                            // '#4B5000'
                                            // ],
                                            data: dataValue
                                        }
                                    ]
                                };
                                setGraphData(graphData2);

                            });


                        });
                    });



                    UserService.getRiasecResult(currentRoom, studentId, 'STUDENT')
                        .then((response) => {
                            setTop1('')
                            setTop2A('')
                            setTop2B('')
                            setSkill([])

                            // TOP Data
                            let res = null
                            if (response.data && response.data.data && response.data.data[0]) {
                                res = response.data.data[0]
                                const top = res.top
                                if (top.top1.length > 0) {
                                    if (top.top1.length === 1) {
                                        setTop1(top.top1[0])
                                        if (top.top2.length > 0) {
                                            if (top.top2.length === 1) {
                                                setTop2A(top.top2[0])
                                            } else if (top.top2.length === 2) {
                                                setTop2A(top.top2[0])
                                                setTop2B(top.top2[1])
                                            }
                                        }
                                    } else if (top.top1.length === 2) {
                                        setTop1(top.top1[0])
                                        setTop2A(top.top1[1])
                                    }
                                }


                                // Set Personality and Occupation Data
                                let s = []
                                if (top && top.top1Select && top.top1Select !== null) {
                                    if (top.top1Select.length >= 3) {
                                        top.top1Select = top.top1Select.substring(0,2);
                                      } 
                                    const t1S = rData.findIndex(x => x.riasec === top.top1Select);
                                    if (t1S) {
                                        s.push(rData[t1S])
                                    }
                                } else {
                                    if (top.top121Abb) {
                                        const t1 = rData.findIndex(x => x.riasec === top.top121Abb);
                                        if (t1) {
                                            s.push(rData[t1])
                                        }
                                    }
                                    if (top.top122Abb) {
                                        const t2 = rData.findIndex(x => x.riasec === top.top122Abb);
                                        if (t2) {
                                            s.push(rData[t2])
                                        }
                                    }
                                }
                                console.log('test skill');
                                console.log(s);
                                setSkill(s)
                            }
                        })

                } catch (error) {

                }

            } else {
                setStyleDashboardS('d-none');
                setStyleDashboardH('d-none')
                const user = AuthService.getCurrentUser();
                const rName = (user.room && user.room.displayName) ? user.room.displayName : '';
                const rRoomId = (user.room && user.room.id) ? user.room.id : '';
                currentY = currentY === '0' ? AuthService.getUserCurrentYear() : currentY;
                currentT = currentT === '0' ? AuthService.getUserCurrentTerm() : currentT;
                currentRoom = currentRoom === '0' ? rRoomId : currentRoom;
                setRoomName(rName);
                setRId(currentRoom)
                // console.log('----------------------------------------');
                // console.log(rName, currentRoom);


                UserService.getRoomDetail(currentRoom).then((response) => {

                    setRoomyear(response.data.data.year);
                    setRoomterm(response.data.data.term);
                    setRoomgrade(response.data.data.grade);
                    setRoomgradeyear(response.data.data.gradeYear);

                })

                UserService.getStudentInRoom(currentRoom).then(
                    (res) => {
                        setTotalStudentCount(res.data.data.students.length);
                        setTotalTeacherCount(res.data.data.teachers.length);
                    });

                UserService.getActivities({
                    roomId: currentRoom,
                    year: currentY,
                    term: currentT
                }).then((res) => {
                    console.log(res);
                    setTotalActivityCount(res.data.total);
                });



                const userDomain = user.domain.name;


                var filterT1 = {
                    "domain": userDomain,
                    "year": currentY,
                    "term": currentT,
                    "role": "STUDENT",
                    "roomId": currentRoom,

                };
                UserService.summaryStrength(filterT1).then((result) => {

                    var studentData = result.student || [];
                    console.log(studentData);

                    var htmlDesktop = '';
                    var htmlMobile = [];
                    $.each(studentData, function (index, value) {

                        htmlMobile.push({
                            'total': `${value.total} ครั้ง`,
                            'image': `/images/strengths/cards/${value.name}.png`,
                        })

                        htmlDesktop += `<div class="pt-4 col-lg-4 col-12 text-center t-20" > <img src="/images/strengths/cards/${value.name}.png" class="imgCard"/><br>${value.total} ครั้ง</div>`;

                    });

                    var htmlDesktop2 = <div dangerouslySetInnerHTML={{ __html: htmlDesktop }} className="row bg-lightness5-blue pb-5 px-5 mrl-0px border-radius-bottom-7px" key="topS" />

                    setRoomStrengthsMobile(htmlMobile);
                    setRoomStrengths(htmlDesktop2);


                });

                //for graph
                UserService.getStrengths().then((response) => {

                    for (const [index, str] of response.data.data.entries()) {
                        newStrengths[str.id] = {
                            image: str.imageUrl,
                            name: str.name,
                            description: str.description
                        }
                    }
                    setStrengths(newStrengths)
                    return newStrengths
                }).then((apiStrengths) => {
                    var filter2 = {
                        "domain": userDomain,
                        "year": currentY,
                        "term": currentT,
                    };
                    // summaryStrength คืนทั้งนักเรียน (student) และครู (teacher) ในครั้งเดียว
                    UserService.summaryStrength(filter2).then((result) => {

                        // จุดเด่นของนักเรียน
                        var studentData = result.student || [];
                        setFriendshipD1(studentData);
                        setTeacherD1(studentData.length > 0);
                        var key1 = [];
                        var timeCount1 = [];
                        $.each(studentData, function (index, value) {
                            timeCount1[value.name] = value.total + " ครั้ง";
                            key1.push(value.name);
                            labelsValueH1.push(newStrengths[value.name]?.name);
                            backgroundColorValueH1.push(color[value.name]);
                            dataValueH1.push(value.total);
                        });
                        var gh1 = {
                            labels: labelsValueH1,
                            datasets: [
                                {
                                    label: 'Rainfall',
                                    backgroundColor: backgroundColorValueH1,
                                    data: dataValueH1
                                }
                            ]
                        };
                        setHGraphData1(gh1);
                        setSetKeyH1(key1);
                        setTimeCount1(timeCount1);

                        // จุดเด่นของคุณครู
                        var teacherData = result.teacher || [];
                        setFriendshipD2(teacherData);
                        setTeacherD2(teacherData.length > 0);
                        var key2 = [];
                        var timeCount2 = [];
                        $.each(teacherData, function (index, value) {
                            timeCount2[value.name] = value.total + " ครั้ง";
                            key2.push(value.name);
                            labelsValueH2.push(newStrengths[value.name]?.name);
                            backgroundColorValueH2.push(color[value.name]);
                            dataValueH2.push(value.total);
                        });
                        var gh2 = {
                            labels: labelsValueH2,
                            datasets: [
                                {
                                    label: 'Rainfall',
                                    backgroundColor: backgroundColorValueH2,
                                    data: dataValueH2
                                }
                            ]
                        };
                        setHGraphData2(gh2);
                        setSetKeyH2(key2);
                        setTimeCount2(timeCount2);

                    });

                });
            }

        }


    }, [])

    const exportLink = (link) => {
        if (link) {
            window.open(link, '_blank').focus();
        }
    }


    const showHideSection = (section) => {
        console.log(section);
        var targetID = $('#' + section);
        var tragetClass = $('.' + section);
        if (targetID.hasClass('showhide-red')) {
            targetID.removeClass('showhide-red');
            targetID.addClass('showhide-green');
            tragetClass.hide();
        } else {
            targetID.removeClass('showhide-green');
            targetID.addClass('showhide-red');
            tragetClass.show();
        }

    }

    return (
        <div>
            <Helmet>
                <title>รายงานกิจกรรมจิตวิทยาเชิงบวกในห้องเรียน - Mindsetmaker.co</title>
                <meta property="og:title" content={`รายงานกิจกรรมจิตวิทยาเชิงบวกในห้องเรียน - Mindsetmaker.co`} />
                <meta property="og:description" content={`รายงานกิจกรรมการเรียนรู้จิตวิทยาเชิงบวกในห้องเรียน และการสื่อสารคุณค่าเชิงบวก ด้วยเครื่องมือปรับใจ ของ ${AuthService.getCurrentUser().domain.displayName}`} />
            </Helmet>
            <Row>
                <Col className="main-detail header-text">
                    <HeaderText cardImage="http://placehold.jp/286x180.png" text1={`รายงาน ห้อง ${roomName}`} cardTitle="" text2="นายวัศพล คนไทย" />
                </Col>
            </Row>
            <Row className={`${styleShow} mb-3 mx-3 d-none`}>
                <Col className={`${styleDashboardH} main-detail bg-dark-blue2  border-radius-12 p-3 text-white font-sarabun`}>

                    <Row>
                        <Col xs={12} md={4}>
                            <div className="d-flex h-100 dashboard-sum">
                                <div className="m-auto d-flex">
                                    <div className="">
                                        <img src="/images/icons/solid.png" height="100" className="mr-2" />
                                    </div>
                                    <div className="m-auto">
                                        <h4>จำนวนเรื่องราวปัจจุบัน</h4>
                                        <h3 className="mb-0">{totalContent} เรื่องราว</h3>
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col xs={12} md={8}>
                            <div className="dashboard-sum2">
                                <h4 className="dashboard-sum2-text1">เรื่องราวดีๆ 3 อันดับแรกที่ถูกเลือกใช้งานมากที่สุดในปัจจุบัน</h4>
                                <ol className="dashboard-sum2-text2">
                                    <li>{topContent && topContent[0] ? topContent[0].title : ''}</li>
                                    <li>{topContent && topContent[1] ? topContent[1].title : ''}</li>
                                    <li>{topContent && topContent[2] ? topContent[2].title : ''}</li>
                                </ol>
                            </div>
                        </Col>
                    </Row>

                </Col>
            </Row>

            <Row>
                <Col className="text-center main-detail pb-5">
                    <CardActivity btnText="ดูรายงาน" />
                </Col>
            </Row>


            <div class={`${styleDashboardH}`}>
                <Row className={`pocketbook ${styleShow} pt-5 pb-5`} style={{ "zIndex": "-1000", "justifyContent": "center", "backgroundColor": "white" }}>
                    <Col className="pt-0" style={{ "maxWidth": "1100px" }}>
                        <Row className="main-detail m-auto text-center">
                            <Col xs={12} className="main-detail text-center px-0 pt-3">
                                <h2 className="font-sarabun-bold">Dashboard ภาพรวมของโรงเรียน</h2>
                            </Col>
                        </Row>




                        <Row className="font-sarabun my-3">
                            <Col xs={12} className="text-center">
                                <p className="font-s30">จำนวน User และจำนวนกิจกรรม</p>
                            </Col>
                            <Col xs={12} lg={6} className="">
                                <p className="text-center text-lg-right pl-lg-0 mb-0" data-testid="dashboard-domain-homeroom-total-student"><img src="/images/icons/person_icon.png" width="10" className="mb-2" /> นักเรียนทั้งหมด {totalStudentCount} คน</p>
                            </Col>
                            <Col xs={12} lg={6} className="">
                                <p className="text-center text-lg-left pl-lg-0 mb-0" data-testid="dashboard-domain-homeroom-total-teacher"><img src="/images/icons/person_icon.png" width="10" className="mb-2" /> คุณครูทั้งหมด {totalTeacherCount} คน</p>
                            </Col>

                        </Row>

                        <div>
                            <Slider {...settings} className="d-block d-lg-none">
                                <div style={{ "marginRight": "20px" }}>
                                    <CardYear year="1" totalActivity={homeroomD1 && homeroomD1[0] ? homeroomD1[0] : null} homeRoomFeature={featureHomeroom} />
                                </div>
                                <div>
                                    <CardYear year="2" totalActivity={homeroomD1 && homeroomD1[1] ? homeroomD1[1] : null} homeRoomFeature={featureHomeroom} />
                                </div>
                                <div>
                                    <CardYear year="3" totalActivity={homeroomD1 && homeroomD1[2] ? homeroomD1[2] : null} homeRoomFeature={featureHomeroom} />
                                </div>
                                <div>
                                    <CardYear year="4" totalActivity={homeroomD1 && homeroomD1[3] ? homeroomD1[3] : null} homeRoomFeature={featureHomeroom} />
                                </div>
                                <div>
                                    <CardYear year="5" totalActivity={homeroomD1 && homeroomD1[4] ? homeroomD1[4] : null} homeRoomFeature={featureHomeroom} />
                                </div>
                                <div>
                                    <CardYear year="6" totalActivity={homeroomD1 && homeroomD1[5] ? homeroomD1[5] : null} homeRoomFeature={featureHomeroom} />
                                </div>

                            </Slider>
                            <Row className="d-none d-lg-flex">
                                <Col xs={12} lg={3} className="pt-4">
                                    <CardYear year="1" totalActivity={homeroomD1 && homeroomD1[0] ? homeroomD1[0] : null} homeRoomFeature={featureHomeroom} />
                                </Col>
                                <Col xs={12} lg={3} className="pt-4">
                                    <CardYear year="2" totalActivity={homeroomD1 && homeroomD1[1] ? homeroomD1[1] : null} homeRoomFeature={featureHomeroom} />
                                </Col>
                                <Col xs={12} lg={3} className="pt-4">
                                    <CardYear year="3" totalActivity={homeroomD1 && homeroomD1[2] ? homeroomD1[2] : null} homeRoomFeature={featureHomeroom} />
                                </Col>
                                <Col xs={12} lg={3} className="pt-4">
                                    <CardYear year="4" totalActivity={homeroomD1 && homeroomD1[3] ? homeroomD1[3] : null} homeRoomFeature={featureHomeroom} />
                                </Col>
                                <Col xs={12} lg={3} className="pt-4">
                                    <CardYear year="5" totalActivity={homeroomD1 && homeroomD1[4] ? homeroomD1[4] : null} homeRoomFeature={featureHomeroom} />
                                </Col>
                                <Col xs={12} lg={3} className="pt-4">
                                    <CardYear year="6" totalActivity={homeroomD1 && homeroomD1[5] ? homeroomD1[5] : null} homeRoomFeature={featureHomeroom} />
                                </Col>
                            </Row>
                        </div>

                        <Row className="font-sarabun mb-3 mb-lg-4 pt-3 pt-lg-5">
                            <Col xs={12} className="text-center">
                                <h3 className="font-sarabun-bold mb-0 pt-4 pt-lg-0">
                                    5 อุปนิสัยเชิงบวกของนักเรียน และคุณครู
                                </h3>
                                <button className="btn-showhide border-gray showhide-red" id="showHideFriendship" onClick={() => showHideSection('showHideFriendship')}> </button>
                            </Col>
                        </Row>
                        <Row className="font-sarabun mb-3 mb-lg-4 showHideFriendship">
                            <Col xs={12} lg={6} className="mt-3 mb-3">
                                <div className="bg-light-blue text-center p-3">
                                    <p className="font-s30 font-weight-bold primary-text"><img src="/images/icons/person_blue.png" width="15" className="mb-2" /> นักเรียน</p>
                                    <p>5 จุดเด่นที่ถูกเลือกมากที่สุดในโรงเรียนจากการประเมินทั้งหมด</p>


                                    <div style={{ "position": "relative" }} className="m-0 p-0">
                                        {
                                            !(headmasterD1 && hGraphData1) ? (
                                                <div className="h-graph pt-5">
                                                    <p className="gray-text5 pt-5 ">ยังไม่มีการประเมิน</p>
                                                </div>

                                            ) : (
                                                <div>
                                                    <Col xs={6} md={6} className="h-graph">
                                                        <div className="m-auto custom-graph">

                                                            {
                                                                (headmasterD1 && hGraphData1) ? (
                                                                    <Doughnut
                                                                        data={hGraphData1}
                                                                        options={{
                                                                            plugins: {
                                                                                legend: {
                                                                                    display: false,
                                                                                    position: 'bottom'
                                                                                }
                                                                            },
                                                                            responsive: true,
                                                                            maintainAspectRatio: true
                                                                        }}
                                                                    />
                                                                ) : (
                                                                    <div></div>
                                                                )
                                                            }
                                                        </div>

                                                    </Col>


                                                    <Col xs={7} md={6} style={{ "top": "0px", "right": "0px", "position": "absolute", "minHeight": "240px" }} className="d-flex pr-0">
                                                        <div className="m-auto w-100">
                                                            {keyH1.map((key, i) => (
                                                                <Col xs={12} className="pl-3 pr-0 d-flex mb-2" key={key}>
                                                                    <div className="d-inline div-dot" style={{ "backgroundColor": color[key] }}></div>
                                                                    <div className="d-grid pl-2 text-left w-100"><h6 className="font-sarabun mb-0">{strengths[key].name} <span className="doNotWrap">{timeCount1[key]}</span></h6></div>
                                                                </Col>
                                                            ))}
                                                        </div>
                                                    </Col>
                                                </div>
                                            )
                                        }
                                    </div>

                                </div>
                            </Col>
                            <Col xs={12} lg={6} className="mt-3 mb-3">
                                <div className="bg-light-blue text-center p-3">
                                    <p className="font-s30 font-weight-bold primary-text"><img src="/images/icons/person_blue.png" width="15" className="mb-2" /> คุณครู</p>
                                    <p>5 จุดเด่นที่ถูกเลือกมากที่สุดในโรงเรียนจากการประเมินทั้งหมด</p>

                                    <div style={{ "position": "relative" }} className="m-0 p-0">
                                        {
                                            !(headmasterD2 && hGraphData2) ? (
                                                <div className="h-graph pt-5">
                                                    <p className="gray-text5 pt-5 ">ยังไม่มีการประเมิน</p>
                                                </div>

                                            ) : (
                                                <div>
                                                    <Col xs={6} md={6} className="h-graph">
                                                        <div className="m-auto custom-graph">
                                                            {
                                                                (headmasterD2 && hGraphData2) ? (
                                                                    <Doughnut
                                                                        data={hGraphData2}
                                                                        options={{
                                                                            plugins: {
                                                                                legend: {
                                                                                    display: false,
                                                                                    position: 'bottom'
                                                                                }
                                                                            },
                                                                            responsive: true,
                                                                            maintainAspectRatio: true
                                                                        }}
                                                                    />
                                                                ) : (
                                                                    <div></div>
                                                                )
                                                            }
                                                        </div>
                                                    </Col>



                                                    <Col xs={7} md={6} style={{ "top": "0px", "right": "0px", "position": "absolute", "minHeight": "240px" }} className="d-flex pr-0">
                                                        <div className="m-auto w-100">
                                                            {keyH2.map((key, i) => (
                                                                <Col xs={12} className="pl-3 pr-0 d-flex mb-2" key={key}>
                                                                    <div className="d-inline div-dot" style={{ "backgroundColor": color[key] }}></div>
                                                                    <div className="d-grid pl-2 text-left w-100"><h6 className="font-sarabun mb-0">{strengths[key].name} <span className="doNotWrap">{timeCount2[key]}</span></h6></div>
                                                                </Col>
                                                            ))}
                                                        </div>
                                                    </Col>
                                                </div>
                                            )
                                        }
                                    </div>
                                </div>
                            </Col>
                        </Row>

                        {rId ? (<ReportSummary roomId={rId} showFor="domain" />) : (<span />)}

                        {
                            (featureHomeroom) ? (
                                <div>
                                    <Row className="font-sarabun mt-3 mb-3 mt-lg-5 mb-lg-4">
                                        <Col xs={12} className="text-center">
                                            <h3 className="font-sarabun-bold mb-0 pt-4">
                                                ผลการทำกิจกรรม Homeroom
                                            </h3>
                                            <button className="btn-showhide border-gray showhide-red" id="showHideHomeroom" onClick={() => showHideSection('showHideHomeroom')}> </button>

                                        </Col>

                                    </Row>
                                    <Row className="font-sarabun mt-3 mx-1 border-lightness5-blue showHideHomeroom" style={{ "borderRadius": "7px" }}>

                                        <Col xs={6} className="bg-lightness5-blue py-3">
                                            <Row>
                                                <Col xs={5} className="text-right">
                                                    <img src="/images/icons/book_blue.png" height="45" className="ml-2" />
                                                </Col>
                                                <Col xs={7}>
                                                    <h4 className="mb-0 s12">จำนวนครั้งกิจกรรม</h4>
                                                    <h3 className="mb-0 font-primary-color font-weight-bold" data-testid="dashboard-domain-homeroom-total-count">{totalActivityCount || '-'} รอบ</h3>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col xs={6} style={{ "borderLeft": 'solid 1px #D5E3FB' }} className="bg-lightness5-blue py-3"><Row>
                                            <Col xs={5} className="text-right">
                                                <img src="/images/icons/stopwatch_blue.png" width="45" />
                                            </Col>
                                            <Col xs={7}>
                                                <h4 className="mb-0 s12">คิดเป็นช่วงเวลาเชิงบวก</h4>
                                                <h3 className="mb-0 font-primary-color font-weight-bold" data-testid="dashboard-domain-homeroom-total-minute">{totalActivityCount * 20}  นาที</h3>
                                            </Col>
                                        </Row>
                                        </Col>
                                    </Row>
                                </div>

                            ) : (
                                <Row></Row>
                            )
                        }
                    </Col>
                </Row>

            </div>


            <div className={`${styleDashboardS}`}>
                <Row className={`pocketbook ${styleFriendShip}`} style={{ "zIndex": "-1000", "backgroundColor": "white" }}>
                    <Col className="pt-5">
                        <Row className="main-detail m-auto text-center">
                            <Col xs={12} className="text-center">
                                <h2 class="font-sarabun-bold font-primary-color mb-3 pt-4">Dashboard ภาพรวมของโรงเรียน</h2>
                            </Col>
                        </Row>
                        <Row className="main-detail m-auto text-center">
                            <Col>
                                {(roomyear && roomterm && roomgradeyear) ? <FriendshipGame year={roomyear} term={roomterm} grade={roomgrade} gradeYear={roomgradeyear} showFilterGradeYear={false} roomId={currentRoom} /> : null}
                            </Col>
                        </Row>
                        <Row className="main-detail m-auto text-center pt-5">
                            <Col xs={12} md={6}>
                                <img src="/images/pocketbook/cover.png" width="350" className="m-auto" style={{ "maxWidth": "100%" }} />
                            </Col>
                            <Col xs={12} md={6} className="g-detail m-auto">
                                <Row>
                                    <Col xs={12} className="main-detail text-center px-0 pt-3">
                                        <h2 className="font-sarabun-bold">ช่วงเวลาที่นักเรียนได้เรียนรู้<span className="doNotWrap">เรื่องราวเชิงบวก</span></h2>
                                    </Col>
                                </Row>
                                <Row className="px-3">
                                    <Col xs={12} className="result-graph px-1 d-flex py-3 border-radius-12 blog-resutl blog-resutl m-auto">
                                        <div className="text-center d-inline d-inline" style={{ "width": '50%', "borderRight": "1px solid #B6C2D5" }}>
                                            <div className="text-left m-auto d-flex" style={{ "width": "fit-content" }}>
                                                <div className="px-1 d-inline"><img src='/images/pocketbook/book.png' className="m-auto" style={{ "height": '40px' }} /></div>
                                                {/* <div className="px-1 d-inline t-12 font-sarabun" >จำนวนครั้งกิจกรรม <br></br><h3 className="font-sarabun-bold primary-text mb-0">{totalActivity || '-'} รอบ</h3></div> */}
                                                <div className="px-1 d-inline t-12 font-sarabun" >จำนวนครั้งกิจกรรม 1<br></br><h3 className="font-sarabun-bold primary-text mb-0">{totalActivityCount || '-'} รอบ</h3></div>
                                            </div>
                                        </div>

                                        <div className="text-center d-inline d-inline" style={{ "width": '50%' }}>
                                            <div className="text-left m-auto d-flex" style={{ "width": "fit-content" }}>
                                                <div className="px-1 d-inline"><img src='/images/pocketbook/stopwatch2.png' className="m-auto" style={{ "width": '40px' }} /></div>
                                                {/* <div className="px-1 d-inline t-12 font-sarabun">คิดเป็นช่วงเวลาเชิงบวก <br></br><h3 className="font-sarabun-bold primary-text mb-0">{totalActivity*20} นาที</h3></div> */}
                                                <div className="px-1 d-inline t-12 font-sarabun">คิดเป็นช่วงเวลาเชิงบวก <br></br><h3 className="font-sarabun-bold primary-text mb-0">{totalActivityCount * 20} นาที</h3></div>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={12} className="main-detail px-0 py-3">
                                        <a href={`/report/overview/${roomId}`} ><div className="w-100 t-b-12 green-text text-center font-sarabun-bold"><u>ดูกิจกรรม Homeroom เพิ่มเติม</u></div></a>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>

                        <hr className="main-detail my-3 my-md-5"></hr>
                        <div className={` ${styleSubFriendShip}`} >

                            <Row>
                                <Col xs={12} className="main-detail px-3 pb-3">
                                    <h2 className="font-sarabun-bold text-center">อุปนิสัยเชิงบวกของเราที่โดดเด่น<span className="doNotWrap">ในเทอมนี้</span></h2>
                                </Col>
                            </Row>
                            <Row className="main-detail m-auto">
                                <Col xs={12} md={6} className="px-0" >
                                    <div id="capture" className="d-flex" style={{ "position": "relative", "left": "0%" }}>
                                        <div className="w-100 m-auto" style={{ "maxWidth": "400px", "zIndex": "2", "padding": "0px 20px 0px 20px" }}>
                                            {
                                                (friendD1 && graphData) ? (
                                                    <Doughnut
                                                        data={graphData}
                                                        options={{
                                                            plugins: {
                                                                legend: {
                                                                    display: false,
                                                                    position: 'bottom'
                                                                }
                                                            },
                                                            responsive: true,
                                                            maintainAspectRatio: true
                                                        }}
                                                    />
                                                ) : (
                                                    <div></div>
                                                )
                                            }
                                        </div>
                                        <div style={{ "position": "absolute", "zIndex": "1" }} className="w-100 text-center graph-percent-text"><h1>{maxValue}%</h1></div>
                                    </div>
                                </Col>

                                <Col xs={12} md={6} className="p-0 pt-3 pb-3 g-detail" style={{ "display": "flex" }} >
                                    <Row className="m-auto">
                                        {key.map((key, i) => (
                                            <Col xs={6} md={4} className="px-3 d-flex" key={key}>
                                                <div className="d-inline div-dot" style={{ "backgroundColor": color[key] }}></div>
                                                <div className="d-grid pl-2"><span className="t-14 font-sarabun">{strengths[key].name} {allPercent[key]}</span></div>
                                            </Col>
                                        ))}
                                    </Row>
                                </Col>

                            </Row>
                            {/* <hr className="main-detail my-3"></hr> */}
                            <Row>
                                <Col xs={12} className="main-detail px-3 pt-3 pb-3">
                                    <h4 className="font-sarabun-bold text-center">เหตุการณ์ที่ทำให้เรามองเห็นอุปนิสัยเชิงบวก<span className="doNotWrap">ของตัวเอง</span></h4>
                                    <div className='border-radius-12 border-blue p-3 text-left overflow-7 div-ans auto-height'>
                                        <div className="font-sarabun">{selfText ? selfText : ''}</div>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} className="px-0 pb-3">
                                    <a href={`/report/friendship/${roomId}`}><div className="w-100 t-b-12 green-text text-center font-sarabun-bold"><u>ดูมุมมองอื่นๆ เพิ่มเติม</u></div></a>
                                </Col>
                                <Col xs={12} className="text-center my-1">
                                    <Button className="bluesky d-inline py-1 py-md-2 px-3 px-md-5  font-sarabun-bold btn btn-primary export-btn" onClick={() => exportLink(`/pocketbook/pdf/${roomId}/${sId}`)} ><h3 className="mb-0 font-weight-bold" >Export สมุดพกจิตวิทยาเชิงบวก</h3></Button>
                                </Col>
                            </Row>
                        </div>
                        <hr className="main-detail my-3 my-md-5"></hr>
                        <Row className="main-detail m-auto text-center">
                            <Col xs={12}>
                                <h3 className="font-sarabun-bold mb-3">
                                    ผลประเมินแบบทดสอบความสนใจทางอาชีพในห้องเรียน
                                </h3>
                            </Col>
                        </Row>

                        {
                            (skill && skill.length > 0) ? (
                                <div>
                                    <Row className="riasec-result-page">
                                        <Col xs={12} className='main-detail most-skill py-3'>
                                            <Row className=''>
                                                <Col xs={12} lg={4} className='text-center d-flex'>
                                                    <Row className='m-auto'>
                                                        <Col xs={12} className='position-relative'>
                                                            <img src='/images/riasec/result-circle.png' className='riasec-circle' width={'100%'} alt='circle' />
                                                            <div className={`r-${skill.length} result-circle-frame position-absolute d-flex`}>
                                                                <div className='m-auto result-circle-text'>
                                                                    {
                                                                        (skill && skill.length > 0) ? (
                                                                            skill.map((item, index) => (
                                                                                <span key={index}>
                                                                                    {
                                                                                        (index > 0) ? (
                                                                                            <br />
                                                                                        ) : (
                                                                                            <span />
                                                                                        )
                                                                                    }
                                                                                    {item.riasec}
                                                                                </span>
                                                                            ))
                                                                        ) : (
                                                                            <span></span>
                                                                        )
                                                                    }
                                                                </div>
                                                            </div>
                                                        </Col>
                                                        <Col xs={12} className="d-block d-md-none"> <h1 className='headline font-sarabun-bold text-center'>Most Remarkable RIASEC Skills</h1></Col>
                                                        <Col xs={6} className='riasec-top'>
                                                            <div>
                                                                <img src='/images/riasec/top1.png' className='r-icon' alt='top1' />
                                                            </div>
                                                            <div className='top1 ml-4' data-testid='riasec-top1'>{top1}</div>
                                                        </Col>
                                                        <Col xs={6} className='riasec-top'>
                                                            <div>
                                                                <img src='/images/riasec/top2.png' className='r-icon' alt='top2' />
                                                            </div>
                                                            <div className='top2 ml-4' data-testid='riasec-top21'>{top2A}</div>
                                                            <div className='top2 ml-4' data-testid='riasec-top22'>{top2B}</div>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                                <Col xs={12} lg={8}>
                                                    <h1 className='headline font-sarabun-bold text-center d-none d-md-block'>Most Remarkable RIASEC Skills</h1>
                                                    <Row>
                                                        <Col xs={12} className='riasec-detail py-3'>
                                                            {
                                                                (skill && skill.length > 0) ? (
                                                                    skill.map((item, index) => (
                                                                        <div key={index}>
                                                                            {
                                                                                (skill && skill.length > 1) ? (
                                                                                    <h3>{item.riasec}</h3>
                                                                                ) : (
                                                                                    <span></span>
                                                                                )
                                                                            }
                                                                            <span className="font-sarabun-bold t-20">
                                                                                {item.personality}
                                                                            </span>
                                                                        </div>
                                                                    ))
                                                                ) : (
                                                                    <div></div>
                                                                )
                                                            }
                                                        </Col>
                                                    </Row>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                    <Row className="riasec-result-page pb-5">

                                        <Col xs={12} className='main-detail'>
                                            <div className='frame mt-5'>
                                                <div className='detail pb-5'>
                                                    {
                                                        (skill && skill.length > 0) ? (
                                                            skill.map((item, index) => (
                                                                <div key={index}>
                                                                    <h3 className='font-sarabun-bold text-center'>{item.riasec} - อาชีพที่อาจจะเป็นไปได้สำหรับบุคลิกภาพนี้</h3>
                                                                    <span className='font-sarabun mb-3 t-20'>
                                                                        {item.occupation}
                                                                    </span>
                                                                </div>
                                                            ))
                                                        ) : (
                                                            <div></div>
                                                        )
                                                    }
                                                </div>
                                            </div>

                                        </Col>

                                        <Col xs={12} className="text-center my-1">
                                            <Button className="bluesky d-inline py-1 py-md-2 px-3 px-md-5  font-sarabun-bold btn btn-primary export-btn" onClick={() => exportLink(`/report/riasec/export/${assessor.toLowerCase()}/${roomId}/${sId}`)} ><h3 className="mb-0 font-weight-bold" >Export ความสนใจทางอาชีพ</h3></Button>
                                        </Col>

                                    </Row>
                                </div>
                            ) : (<div className='text-center font-sarabun-bold my-3'>ยังไม่มีผลประเมิน</div>)}
                    </Col>
                </Row>
            </div>


            <div class={`${styleDashboardT}`}>

                <Row className={`pocketbook ${styleShow} pt-5 pb-0`} style={{ "zIndex": "-1000", "justifyContent": "center", "backgroundColor": "white" }}>
                    <Col className="pt-0" style={{ "maxWidth": "1100px" }}>
                        <Row>
                            <Col xs={12} className="text-center">
                                <h2 class="font-sarabun-bold font-primary-color mb-3 pt-4">Dashboard ภาพรวมของโรงเรียน</h2>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                {(roomyear && roomterm && roomgradeyear) ? <FriendshipGame year={roomyear} term={roomterm} grade={roomgrade} gradeYear={roomgradeyear} showFilterGradeYear={false} roomId={currentRoom} /> : null}
                            </Col>
                        </Row>
                        <Row className="mt-5 bg-lightness5-blue mr-lg-0 ml-lg-0 d-block d-lg-none" style={{
                            "borderTop": 'solid 1px #D5E3FB'
                        }}>
                            <Col xs={12} md={6} className="p-2 p-lg-3 text-center">
                                <p className="font-primary-color font-s30 font-weight-bold">ภาพรวมของโรงเรียน</p>
                                <p className="font-s30">5 อุปนิสัยเชิงบวกของนักเรียน<br className="d-none d-lg-block"></br>และคุณครูในโรงเรียน</p>
                            </Col>
                            <Col xs={12} md={6} className="p-2 p-lg-3 text-center">
                                <img src="/images/report/teacher_report.png" className="mr-2 w-100" />
                            </Col>
                        </Row>

                        <Row className="mt-5 bg-lightness5-blue border-radius-top-7px mr-lg-0 ml-lg-0 d-none d-lg-flex" style={{
                            "borderLeft": 'solid 1px #D5E3FB',
                            "borderRight": 'solid 1px #D5E3FB',
                            "borderTop": 'solid 1px #D5E3FB'
                        }}>
                            <Col xs={12} md={6} className="p-2 p-lg-3 text-center">
                                <p className="font-primary-color font-s30 font-weight-bold">ภาพรวมของโรงเรียน</p>
                                <p className="font-s30">5 อุปนิสัยเชิงบวกของนักเรียน<br className="d-none d-lg-block"></br>และคุณครูในโรงเรียน</p>
                            </Col>
                            <Col xs={12} md={6} className="p-2 p-lg-3 text-center">

                                <img src="/images/report/teacher_report.png" className="mr-2 w-100" style={{
                                    "position": 'absolute',
                                    "right": '0px',
                                    "bottom": '0px'
                                }} />
                            </Col>
                        </Row>

                        <Row className="font-sarabun b-report-t">
                            <Col xs={12} lg={6} className="mt-3 mb-3 px-1">
                                <div className="text-center">
                                    <p className="font-s30 font-weight-bold primary-text"><img src="/images/icons/person_blue.png" width="15" className="mb-2" /> นักเรียน</p>
                                    <p>5 จุดเด่นที่ถูกเลือกมากที่สุดในโรงเรียนจากการ<span className="doNotWrap">ประเมินทั้งหมด</span></p>

                                    {
                                        (teacherD1 && hGraphData1) ? (
                                            <div style={{ "position": "relative" }} className="m-0 p-0">
                                                <Col xs={6} md={6} className="h-graph">
                                                    <div className="m-auto custom-graph">

                                                        <Doughnut
                                                            data={hGraphData1}
                                                            options={{
                                                                plugins: {
                                                                    legend: {
                                                                        display: false,
                                                                        position: 'bottom'
                                                                    }
                                                                },
                                                                responsive: true,
                                                                maintainAspectRatio: true
                                                            }}
                                                        />

                                                    </div>
                                                </Col>

                                                <Col xs={7} md={6} style={{ "top": "0px", "right": "0px", "position": "absolute", "minHeight": "240px" }} className="d-flex pr-0">
                                                    <div className="m-auto w-100">
                                                        {keyH1.map((key, i) => (
                                                            <Col xs={12} className="pl-3 pr-0 d-flex mb-2" key={key}>
                                                                <div className="d-inline div-dot" style={{ "backgroundColor": color[key] }}></div>
                                                                <div className="d-grid pl-2 text-left w-100"><h6 className="font-sarabun mb-0">{strengths[key].name} <span className="doNotWrap">{timeCount1[key]}</span></h6></div>
                                                            </Col>
                                                        ))}
                                                    </div>
                                                </Col>

                                            </div>

                                        ) : (
                                            <div className="text-center font-sarabun pt-5">ยังไม่มีผลประเมิน</div>
                                        )
                                    }


                                </div>
                            </Col>
                            <Col xs={12} lg={6} className="mt-3 mb-3 px-1">
                                <div className="text-center b-report-gray">
                                    <p className="font-s30 font-weight-bold primary-text"><img src="/images/icons/person_blue.png" width="15" className="mb-2" /> คุณครู</p>
                                    <p>5 จุดเด่นที่ถูกเลือกมากที่สุดในโรงเรียนจากการ<span className="doNotWrap">ประเมินทั้งหมด</span></p>
                                    {
                                        (teacherD2 && hGraphData2) ? (
                                            <div style={{ "position": "relative" }} className="m-0 p-0">
                                                <Col xs={6} md={6} className="h-graph">
                                                    <div className="m-auto custom-graph">

                                                        <Doughnut
                                                            data={hGraphData2}
                                                            options={{
                                                                plugins: {
                                                                    legend: {
                                                                        display: false,
                                                                        position: 'bottom'
                                                                    }
                                                                },
                                                                responsive: true,
                                                                maintainAspectRatio: true
                                                            }}
                                                        />
                                                    </div>
                                                </Col>

                                                <Col xs={7} md={6} style={{ "top": "0px", "right": "0px", "position": "absolute", "minHeight": "240px" }} className="d-flex pr-0">
                                                    <div className="m-auto w-100">
                                                        {keyH2.map((key, i) => (
                                                            <Col xs={12} className="pl-3 pr-0 d-flex mb-2" key={key}>
                                                                <div className="d-inline div-dot" style={{ "backgroundColor": color[key] }}></div>
                                                                <div className="d-grid pl-2 text-left w-100"><h6 className="font-sarabun mb-0">{strengths[key].name} <span className="doNotWrap">{timeCount2[key]}</span></h6></div>
                                                            </Col>
                                                        ))}
                                                    </div>
                                                </Col>

                                            </div>
                                        ) : (
                                            <div className="text-center font-sarabun pt-5">ยังไม่มีผลประเมิน</div>
                                        )
                                    }
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} className="text-center">
                                <h3 class="font-sarabun-bold mb-3 pt-4">ผลการทำกิจกรรม Homeroom</h3>
                            </Col>
                        </Row>
                        <Row className="font-sarabun mx-1 border-lightness5-blue" style={{ "borderRadius": "7px" }}>
                            <Col xs={6} className="bg-lightness5-blue py-3">
                                <Row>
                                    <Col xs={5} className="text-right">
                                        <img src="/images/icons/book_blue.png" height="45" className="ml-2" />
                                    </Col>
                                    <Col xs={7}>
                                        <h4 className="mb-0 s12">จำนวนครั้งกิจกรรม</h4>
                                        <h3 className="mb-0 font-primary-color font-weight-bold" data-testid="dashboard-homeroom-total-count">{totalActivityCount || '-'} รอบ</h3>
                                    </Col>
                                </Row>
                            </Col>
                            <Col xs={6} style={{
                                "borderLeft": 'solid 1px #D5E3FB'
                            }} className="bg-lightness5-blue py-3">
                                <Row>
                                    <Col xs={5} className="text-right">
                                        <img src="/images/icons/stopwatch_blue.png" width="45" />
                                    </Col>
                                    <Col xs={7}>
                                        <h4 className="mb-0 s12">คิดเป็นช่วงเวลาเชิงบวก</h4>
                                        <h3 className="mb-0 font-primary-color font-weight-bold" data-testid="dashboard-homeroom-total-minute">{totalActivityCount * 20}  นาที</h3>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>

                        <Row className="main-detail m-auto text-center">
                            <Col xs={12} className="main-detail text-center px-0 pt-5">
                                <h2 className="font-sarabun-bold font-primary-color">ข้อมูลในห้องเรียน {roomName}</h2>
                            </Col>
                        </Row>


                        <Row className="font-sarabun my-3">
                            {/* <Col xs={12} className="text-center">
                                <p className="font-s30" data-testid="dashboard-room-total-user-label">จำนวน User และจำนวนกิจกรรม</p>
                            </Col> */}
                            <Col xs={12} lg={6} className="">
                                <p className="text-center text-lg-right pl-lg-0 mb-0" data-testid="dashboard-room-total-student"><img src="/images/icons/person_icon.png" width="10" className="mb-2" /> นักเรียนทั้งหมด {totalStudentCount} คน</p>
                            </Col>
                            <Col xs={12} lg={6} className="">
                                <p className="text-center text-lg-left pl-lg-0 mb-0" data-testid="dashboard-room-total-teacher"><img src="/images/icons/person_icon.png" width="10" className="mb-2" /> คุณครูทั้งหมด {totalTeacherCount} คน</p>
                            </Col>
                        </Row>
                    </Col>
                </Row>

                <Row className={`pocketbook ${styleFriendShip} pb-5`} style={{ "zIndex": "-1000", "justifyContent": "center", "backgroundColor": "white" }}>
                    <Col className="pt-0" style={{ "maxWidth": "1100px" }}>

                        <Row className="font-sarabun d-block d-lg-none">
                            <Col xs={12} className="pt-2 text-white bg-lightness2-blue m-0">
                                <p className="font-s30 text-center mb-0 py-2">จุดเด่นของนักเรียนในห้องเรียน</p>
                            </Col>
                            <Col xs={12} className="m-0 bg-lightness5-blue">
                                <p className="text-center  m-0 p-3 ">5 จุดเด่นที่ถูกเลือกมากที่สุดในห้องเรียนจากการประเมินทั้งหมด</p>
                            </Col>
                        </Row>

                        <Row className="font-sarabun d-none d-lg-flex">
                            <Col xs={12} className="pt-2 text-white">
                                <p className="font-s30 text-center bg-lightness2-blue border-radius-top-7px mb-0 py-2">จุดเด่นของนักเรียนในห้องเรียน</p>
                            </Col>
                            <Col xs={12} className="m-0">
                                <p className="text-center  mt-0 mb-0 p-3 bg-lightness5-blue">5 จุดเด่นที่ถูกเลือกมากที่สุดในห้องเรียน<span className="doNotWrap">จากการประเมินทั้งหมด</span></p>
                            </Col>
                        </Row>
                        {roomStrengthsMobile[0] || roomStrengthsMobile[1] || roomStrengthsMobile[2] || roomStrengthsMobile[3] || roomStrengthsMobile[4] ?
                            <Slider  {...settings} className="row d-block d-lg-none bg-lightness5-blue pb-4">

                                {roomStrengthsMobile[0] ? (

                                    <div style={{ "marginRight": "20px" }} >
                                        <div class="text-center t-20"> <img src={roomStrengthsMobile[0].image} class="imgCard" /> {roomStrengthsMobile[0].total}</div>
                                    </div>
                                ) : ''}


                                {roomStrengthsMobile[1] ? (
                                    <div>
                                        <div class="text-center t-20"> <img src={roomStrengthsMobile[1].image} class="imgCard" /> {roomStrengthsMobile[1].total}</div>
                                    </div>
                                ) : ''}

                                {roomStrengthsMobile[2] ? (
                                    <div>
                                        <div class="text-center t-20"> <img src={roomStrengthsMobile[2].image} class="imgCard" /> {roomStrengthsMobile[2].total}</div>
                                    </div>
                                ) : ''}


                                {roomStrengthsMobile[3] ? (
                                    <div>
                                        <div class="text-center t-20"> <img src={roomStrengthsMobile[3].image} class="imgCard" /> {roomStrengthsMobile[3].total}</div>
                                    </div>
                                ) : ''}


                                {roomStrengthsMobile[4] ? (
                                    <div>
                                        <div class="text-center t-20"> <img src={roomStrengthsMobile[4].image} class="imgCard" /> {roomStrengthsMobile[4].total}</div>
                                    </div>
                                ) : ''}



                            </Slider>
                            : <div className="text-center bg-lightness5-blue font-sarabun">ยังไม่มีผลประเมิน</div>
                        }

                        <Row className="d-none d-lg-flex">
                            <Col className="">
                                {roomStrengths}
                            </Col>
                        </Row>

                        {rId ? (<ReportSummary roomId={rId} showFor="room" customBorder={true} customSubtitle="จากการทำประเมินแล้ว" />) : (<span />)}

                    </Col>
                </Row>

            </div>



            <WelcomeDialog />

        </div>
    );
};

export default ReportPage;